import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

export const OrdersOverviewLayout = (Component: FC<any>) => (props: any) => {
  return (
    <div className='orders-overview-layout'>
      <div className='TabLinks'>
        <NavLink to={Routes.OrdersOverviewPage.path}>
          <Icon.OrderIcon />
          Orders Overview
        </NavLink>
      </div>
      <Component {...props} />
    </div>
  );
};
